import { render, staticRenderFns } from "./N8nChatWidget.vue?vue&type=template&id=5434f69e&scoped=true"
import script from "./N8nChatWidget.vue?vue&type=script&lang=js"
export * from "./N8nChatWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434f69e",
  null
  
)

export default component.exports